import React, { useState, useCallback, useMemo } from "react";
import settingable from "fantastic/components/hoc/settingable";
import Copywriter from "shared/components/copywriter/App";
import Prompts from "shared/components/Prompts";
import setPrompt from "fantastic/actions/setPrompt";
import connectActions from "fantastic/lib/connectActions";
import directSettings from "fantastic/lib/directSettings";

const BlockSettings = ({ selected, update, selectedNode, openPrompt }) => {

  const insert = (data) => {
    tinyMCE.activeEditor.selection.setRng(window.range);
    tinyMCE.activeEditor.insertContent(data, tinyMCE.activeEditor.selection.getContent());
  }

  const contentFromRange = () => {
    if (!window.range) return;

    return Array.prototype.reduce.call(
      window.range.cloneContents().childNodes, 
      (result, node) => result + (node.outerHTML || node.nodeValue),
      ''
    );
  };

  const content = window.range ? contentFromRange() : selectedNode.contents;
  
  const onChange = useCallback((value) => {
    openPrompt(selectedNode.id, false);

    if (window.range) {
      insert(value);
    } else {
      update(selected, { contents: value });
    }
    window.range = null;
  }, [selected, window.range]);

  const props = useMemo(() => ({
    content,
    onChange
  }), [content, onChange]);

  const { ai_copywriter } = directSettings();

  return (
    <div>
      <div className="form-group fantastic-image-settings__buttons">
        { selectedNode.meta.prompt && <Copywriter {...props} onCancel={ () => { openPrompt(selectedNode.id, false); window.range = null}  }/> }
        { ai_copywriter &&
          <Prompts {...props}>
            <button className="btn btn-form btn-with-icon btn-with-gradient-border">
              <i className="fi fi-sparkles"></i>
              <span>{i18n.t('assistant.change_with_ai')}</span>
              <i className="fi fi-chevron-down" />
            </button>
          </Prompts>
        }
      </div>
    </div>
  );
};

export default connectActions({
  openPrompt: setPrompt
})(settingable("background", "padding", "visibility")(BlockSettings));
